import * as Cookies from 'js-cookie'
import * as React from 'react'

import { store } from '@src/App'
import { initToken, loadCheggAuth } from '../state/auth/actions'
import { allocation } from '../state/experiment'
import { setExperimentVariant } from '../state/experiment/actions'
import { checkInitialCategory } from '../state/workspace/actions'

export const useBootstrapApp = (shouldRedirect: boolean): void => {
  React.useEffect(() => {
    if (!shouldRedirect) {
      store.dispatch(setExperimentVariant({ variant: Cookies.get(allocation) }))
      store.dispatch(initToken())
      store.dispatch(checkInitialCategory())
      store.dispatch(loadCheggAuth())
    }
  }, [shouldRedirect])
}



// WEBPACK FOOTER //
// ./src/hooks/useBootstrapApp.tsx